import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/categories/CategoriesClient.tsx");
